<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        @if (isMultiple) {
            <kendo-multiselect
                [ngClass]="generateInputStyle()"
                [id]="id"
                [adaptiveTitle]="title | translate"
                [textField]="textField"
                [valueField]="valueField"
                [fillMode]="'flat'"
                [valuePrimitive]="valuePrimitive"
                [data]="filteredOptions()"
                [filterable]="true"
                [clearButton]="isRequired !== true || isClearable"
                [readonly]="isDisabled"
                [popupSettings]="popupSettings"
                [(ngModel)]="value"
                (valueChange)="onValueChange($event)"
                (inputFocus)="onFocusIn()"
                (inputBlur)="onFocusOut()"
                (filterChange)="filterOptions($event)">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <div class="p-1">
                        <label class="k-checkbox-label">{{ dataItem[textField] | translate }}</label>
                    </div>
                </ng-template>
            </kendo-multiselect>
        } @else if (isFilterable) {
            <kendo-combobox
                data-container="body"
                [ngClass]="generateInputStyle()"
                [id]="id"
                [adaptiveTitle]="title | translate"
                [textField]="textField"
                [valueField]="valueField"
                [valuePrimitive]="valuePrimitive"
                [data]="filteredOptions()"
                [filterable]="true"
                [clearButton]="!isRequired || isClearable"
                [disabled]="isDisabled"
                [readonly]="isDisabled"
                [popupSettings]="popupSettings"
                [(ngModel)]="value"
                (valueChange)="onValueChange($event)"
                (inputFocus)="onFocusIn()"
                (inputBlur)="onFocusOut()"
                (filterChange)="filterOptions($event)" />
        } @else {
            <kendo-dropdownlist
                [ngClass]="generateInputStyle()"
                [id]="id"
                [adaptiveTitle]="title | translate"
                [data]="options()"
                [textField]="textField"
                [valueField]="valueField"
                [valuePrimitive]="valuePrimitive"
                [popupSettings]="popupSettings"
                [defaultItem]="defaultItem"
                [disabled]="isDisabled"
                [readonly]="isDisabled"
                [required]="isRequired"
                [(ngModel)]="value"
                (focusin)="onFocusIn()"
                (focusout)="onFocusOut()"
                (valueChange)="onValueChange($event)" />
        }
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            @if (customRoute) {
                <app-link [route]="[customRoute.path, value]" [checkPermission]="false">
                    <span kendoTooltip [title]="formatedSelectedOptions()">
                        {{ formatedSelectedOptions() }}
                    </span>
                </app-link>
            } @else {
                <span kendoTooltip [title]="formatedSelectedOptions()">
                    {{ formatedSelectedOptions() }}
                </span>
            }
        </div>
    }
</app-input-label>
